/** API client for comment threads on map nodes. */

import { apiGet, apiPost, apiPatch, apiDelete } from '@/api/client';

export interface Comment {
  commentId: string;
  nodeId: string;
  parentCommentId?: string;
  authorId: string;
  authorEmail: string;
  text: string;
  createdAt: string;
  resolved: boolean;
}

interface ListCommentsResponse {
  comments: Comment[];
}

interface SingleCommentResponse {
  comment: Comment;
}

export async function listComments(
  mapId: string,
  nodeId?: string,
): Promise<Comment[]> {
  const query = nodeId ? `?nodeId=${encodeURIComponent(nodeId)}` : '';
  const res = await apiGet<ListCommentsResponse>(
    `/maps/${mapId}/comments${query}`,
  );
  return res.comments;
}

export async function addComment(
  mapId: string,
  nodeId: string,
  text: string,
  parentCommentId?: string,
): Promise<Comment> {
  const res = await apiPost<SingleCommentResponse>(
    `/maps/${mapId}/comments`,
    { nodeId, text, ...(parentCommentId ? { parentCommentId } : {}) },
  );
  return res.comment;
}

export async function updateComment(
  mapId: string,
  commentId: string,
  updates: { resolved?: boolean; text?: string },
): Promise<Comment> {
  const res = await apiPatch<SingleCommentResponse>(
    `/maps/${mapId}/comments/${commentId}`,
    updates,
  );
  return res.comment;
}

export async function deleteComment(
  mapId: string,
  commentId: string,
): Promise<void> {
  await apiDelete(`/maps/${mapId}/comments/${commentId}`);
}
